<template>
  <div class="app">
    <header-component />
    <div class="app__content">
      <router-view />
    </div>
    <footer-component />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Watch } from 'vue-property-decorator'
import HeaderComponent from './layout/header.vue'
import FooterComponent from './layout/footer.vue'
import { config } from './setup/config'
import defaultBG from '@/assets/images/background.png'

@Component({
  components: {
    HeaderComponent,
    FooterComponent
  },
  created () {
    const branding = config.company.customBranding
    if (branding.useCustomBranding) {
      branding.customBackgroundPath
        ? (document.body.style.backgroundImage = `url(${branding.customBackgroundPath})`)
        : ''
    } else {
      document.body.style.backgroundImage = `url(${defaultBG})`
    }
  },
})
export default class AppComponent extends Vue {
  @Watch('$i18n.locale', { immediate: true })
  public syncronizeTitleWithLocale () {
    document.title = this.$t('global.page.title') as string
  }
}
</script>

<style lang="scss">
html,
body {
  font-family: $font-family-primary;
  font-size: $font-size-normal;
  height: 100%;
  margin: 0;
  padding: 0;
  color: $text-primary;
  background-position: -20vw -10vh;
  background-size: 200vh;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

.app {
  min-height: 100vh;
  display: flex;
  flex-flow: column nowrap;
  max-width: 1080px;
  margin: 0 auto;

  &__content {
    flex: 1;
    padding: $content-padding;
  }
}

.link-list {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: 0 -40px;
  &::after {
    content: "";
    flex: 1 0 0;
    margin: 40px 40px 10px;
  }
}

.link {
  flex: 0 0 25%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin: 30px 0 0;
  &__content {
    padding: 15px;
    border-radius: 15px;
    transition: background-color .1s;
    color: $text-primary;
    text-decoration: none;
    cursor: pointer;
    &:hover {
      background-color: rgba(224, 224, 224, 0.2);
    }
  }
  &__logo {
    width: 200px;
    height: 200px;
    border-radius: 400px;
    background-color: $light-grey;
    box-shadow: 0px 4px 6px rgba(66, 66, 66, 0.05);
  }
  &__logo-img {
    width: 100%;
  }
  &__title {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
